import { render, staticRenderFns } from "./SmartListsNew.vue?vue&type=template&id=cf08f8e0"
import script from "./SmartListsNew.vue?vue&type=script&lang=js"
export * from "./SmartListsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports